"use client";

import Link from "next/link";
import Image from "next/image";
import { useLanguage } from "@/lib/i18n/LanguageContext";

export default function Footer() {
  const { t } = useLanguage();

  return (
    <footer className="border-t border-gray-700 bg-gray-800 overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-8 pb-24 lg:pb-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-8 text-sm text-gray-300">
          {/* Left Side: Copyright & Payments */}
          <div className="flex flex-col items-center md:items-start gap-3">
            <p className="text-center md:text-left" suppressHydrationWarning>
              © {new Date().getFullYear()} CONFY. {t('footer.rights')}.
            </p>
            <div className="flex items-center gap-3 pt-1">
              <span className="text-gray-500">
                {t('footer.paymentsAccepted')}
              </span>
              <div className="flex items-center gap-3">
                <Image
                  src="https://courses3.confy.cc/storage/v1/object/public/misc/visa_light.svg"
                  alt="Visa"
                  width={40}
                  height={14}
                  className="h-3.5 w-auto opacity-70 hover:opacity-100 transition-opacity"
                />
                <Image
                  src="https://courses3.confy.cc/storage/v1/object/public/misc/mc_check.svg"
                  alt="Mastercard"
                  width={40}
                  height={14}
                  className="h-3.5 w-auto opacity-70 hover:opacity-100 transition-opacity"
                />
              </div>
            </div>
          </div>

          {/* Right Side: Links & Support */}
          <div className="flex flex-col items-center md:items-end gap-3">
            <div className="flex flex-wrap justify-center md:justify-end items-center gap-x-4 gap-y-1 sm:gap-x-6 text-xs sm:text-sm">
              <Link
                href="/for-organizers"
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                {t('footer.organizer')}
              </Link>
              <Link
                href="/terms"
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                {t('footer.terms')}
              </Link>
              <Link
                href="/privacy"
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                {t('footer.privacy')}
              </Link>
              <a
                href="mailto:support@confy.cc?subject=Bug Report"
                className="hover:text-white transition-colors whitespace-nowrap"
              >
                {t('footer.reportBug')}
              </a>
            </div>
            <a
              href="mailto:support@confy.cc"
              className="text-gray-400 hover:text-white transition-colors flex items-center gap-2 group"
            >
              <span className="text-gray-500">{t('footer.support')}:</span>
              <span className="font-medium text-blue-400/80 group-hover:text-blue-400 transition-colors">support@confy.cc</span>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}